import {Button, Form, Input} from "antd";
import React, {ReactNode, useState} from 'react';
import {connect} from "react-redux";
import {bindActionCreators, Dispatch} from "redux";
import arrowBack from "../../../../assets/images/arrow-left.svg";
import arrow from "../../../../assets/images/button-arrow-blue.svg";
import {FormValuesCCSave} from "../../../../core/models/custom/formValuesCCSave";
import {FormValuesCCSaveExtended} from "../../../../core/models/custom/formValuesCCSaveExtended";
import {AnswerState} from "../../../../core/services/answerService/answer/types";
import FirebaseService from "../../../../core/services/firebaseService/firebase.service";
import {CreditCard} from "../../../../core/utilities/creditCard";
import {Errors} from "../../../../core/utilities/errors";
import {IStore} from "../../../../core/utilities/reducers";
import FirebaseKey from "../../../FirebaseKey/FirebaseKey";
import "./CCSaveForm.scss";

interface IProps {
  isNewcomer: boolean;
  isLoading: boolean;
  callbackSubmit: (values?: FormValuesCCSaveExtended) => void;
  answerState: AnswerState;
}

enum FieldNames {
  number = 'number',
  expiry = 'expiry',
  cvv = 'cvv',
}

const CCSaveForm = (props: IProps) => {
  const [isErrorCardData, setErrorCardData] = useState(false);
  const [isSubmitted, setSubmitted] = useState(false);
  const [cardDataTrigger, setCardDataTrigger] = useState(true);
  const [form] = Form.useForm();
  const creditCardNumberLen = 19;
  
  function isSaveError(): boolean {
    const {error} = props.answerState;
    return !!error && Errors.isSaveFailedError(error);
  }
  
  function isCardDataError(): boolean {
    const number = form.getFieldValue(FieldNames.number);
    const expiry = form.getFieldValue(FieldNames.expiry);
    const cvv = form.getFieldValue(FieldNames.cvv);
    return (
      (!number || number.length < creditCardNumberLen) ||
      (!expiry || expiry.length < 5) ||
      (!cvv || cvv.length < 3)
    );
  }
  
  function handleChange(e: any): void {
    const id = e.target.id;
    if (
      id === FieldNames.number ||
      id === FieldNames.expiry ||
      id === FieldNames.cvv
    ) {
      setErrorCardData(isCardDataError());
    }
  }
  
  function handleChangeNumber(value: string): void {
    const number = CreditCard.formatCreditCardNumber(value);
    form.setFieldsValue({number});
    setCardDataTrigger(!cardDataTrigger);
  }
  
  function handleChangeExpiry(value: string): void {
    const expiry = CreditCard.formatExpirationDate(value);
    form.setFieldsValue({expiry});
    setCardDataTrigger(!cardDataTrigger);
  }
  
  function handleChangeCvc(value: string): void {
    const cvv = CreditCard.formatCVC(value);
    form.setFieldsValue({cvv});
    setCardDataTrigger(!cardDataTrigger);
  }
  
  function handleFinish(values: FormValuesCCSave): void {
    setSubmitted(true);
    const cardNo = values.number.replaceAll(' ', '');
    let expiryMonth = values.expiry.split('/')[0];
    if (expiryMonth.length === 1) {
      expiryMonth = `0${expiryMonth}`;
    }
    const expiryYear = `20${values.expiry.split('/')[1]}`;
    FirebaseService.logEvent(FirebaseService.user_count_saved_card_continue_click);
    props.callbackSubmit({
      cvv: values.cvv,
      cardNo,
      expiryMonth,
      expiryYear,
    });
  }
  
  function handleFinishFailed(): void {
    setErrorCardData(isCardDataError());
    setSubmitted(true);
  }
  
  function renderCardData(): ReactNode {
    return (
      <React.Fragment>
        <div className={`card-data ${(isSubmitted && (isErrorCardData || isSaveError())) && 'error'}`}>
          <Form.Item
            name={FieldNames.number}
            rules={[{required: true, len: creditCardNumberLen, message: ''}]}
          >
            <Input
              className={`form-input number ${form.getFieldValue(FieldNames.number)?.length > 0 && 'data'}`}
              type="tel"
              placeholder={FirebaseService.getValue(FirebaseService.cc_ph_card_number)}
              onChange={e => handleChangeNumber(e.target.value)}
            />
          </Form.Item>
          <Form.Item
            name={FieldNames.expiry}
            rules={[{required: true, message: ''}]}
          >
            <Input
              className={`form-input expiry ${form.getFieldValue(FieldNames.expiry)?.length > 0 && 'data'}`}
              type="tel"
              placeholder="AA/YY"
              onChange={e => handleChangeExpiry(e.target.value)}
            />
          </Form.Item>
          <div className="separator"/>
          <Form.Item
            name={FieldNames.cvv}
            rules={[{required: true, message: ''}]}
          >
            <Input
              className={`form-input cvv ${form.getFieldValue(FieldNames.cvv)?.length > 0 && 'data'}`}
              type="tel"
              placeholder="CVV"
              onChange={e => handleChangeCvc(e.target.value)}
            />
          </Form.Item>
        </div>
        {
          isSubmitted && isErrorCardData &&
          <div className="error-text">
            <FirebaseKey firebaseKey={FirebaseService.cc_ph_error}/>
          </div>
        }
      </React.Fragment>
    );
  }
  
  return (
    <Form
      form={form}
      id="cc-save-form"
      onChange={handleChange}
      onFinish={handleFinish}
      onFinishFailed={handleFinishFailed}
    >
      <div className="form-title">Kart bilgileri</div>
      {renderCardData()}
      <div className="save-card-note">
        <FirebaseKey
          firebaseKey={props.isNewcomer ? FirebaseService.cc_save_card_first_time_note : FirebaseService.cc_save_card_note}
        />
      </div>
      <div className="buttons">
        <Button
          className="app-button secondary"
          disabled={props.isLoading}
          onClick={() => props.callbackSubmit(undefined)}
        >
          <img src={arrowBack} alt="arrow"/>
        </Button>
        <Button
          className="app-button"
          htmlType="submit"
          disabled={props.isLoading}
        >
          ÖDEME YAP
          <img className="arrow" src={arrow} alt="arrow"/>
        </Button>
      </div>
    </Form>
  );
}

const mapDispatchToProps = (dispatch: Dispatch) => {
  return bindActionCreators(
    {},
    dispatch,
  );
};
const mapStateToProps = (store: IStore) => {
  return {
    answerState: store.answer,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CCSaveForm);
